"use client";

import { useId } from "react";
import { useCarousel } from "./carousel.context";
import type { CarouselItemProps } from "./types/carousel-item.types";
import { carouselItemStyles } from "./styles/carousel-item.styles";

export const CarouselItem: React.FC<CarouselItemProps> = (props) => {
  const internalId = useId();

  const { id = internalId, children, className, ...rest } = props;

  const { activeId, loop } = useCarousel();

  const classes = carouselItemStyles({ loop, className });

  return (
    <div id={id} className={classes} data-active={activeId === id} {...rest}>
      {children}
    </div>
  );
};

CarouselItem.displayName = "CarouselItem";
